$(document).ready(function(){
    $('.toggle').click(function(){
      $(this).toggleClass('open');
      $(this).siblings('.mobile-navigation').slideToggle();
    });

    /* Active Link Styling */
    var navLinks = document.querySelectorAll("header a, footer a, a");
    var getActiveLink = navLinks.forEach((item) => {
        if (item.href === window.location.href) {
            item.classList.add("active-link");
        }
    });

    /* Dropdown */
    var $megaMenuToggle = $('.folder-toggle');
  	$megaMenuToggle.each(function(){
    	var $currentFolder = $(this);
      	$currentFolder.on('click', function(e) {
          e.preventDefault();
          var $currentFolderMenuId = $(this).attr('href');
          var $megaMenuId = $currentFolderMenuId.substr($currentFolderMenuId.indexOf("#")+1);
          if ($(this).hasClass('mega-active')) {
              $(this).removeClass('mega-active');
              $('.mega-menu').removeClass('mega-active');
          } else {
            $('.folder-toggle.mega-active').removeClass('mega-active');
            $('.mega-menu.mega-active').removeClass('mega-active');
            $currentFolder.addClass('mega-active');
            $('.mega-menu').each(function(){
          		var $megaMenu = $(this);
          		if ($megaMenu.attr('id') == $megaMenuId) {
              		$megaMenu.addClass('mega-active');
          		} else {}
        	});
          }
       });
    });
  
  	/* Variants */
    if( typeof product_variants_removed != "undefined" ) {    // was there items to be removed?
    var $addToCartForm = $('form[action="/cart/add"]');
    if (window.MutationObserver && $addToCartForm.length) {
      if (typeof observer === 'object' && typeof observer.disconnect === 'function') {
        observer.disconnect();
      }
      var config = { childList: true, subtree: true };
      var observer = new MutationObserver(function() {
        product_variants_removed.forEach(function(item){
          $('.single-option-selector option').filter(function() { return $(this).text() === item; }).remove();
        });
        observer.disconnect();
      });
      observer.observe($addToCartForm[0], config);
      $('.single-option-selector').trigger('change');
    }
  }
});